import { FormControl, InputLabel, MenuItem, Paper, IconButton, Tab, Button, Divider, Grid, Select, Tabs, Typography, Popover } from "@mui/material";
import { Box } from "@mui/system";
import { values } from "pdf-lib";
import routes from "../../Utils/routes";
import MentorshipContainer from "./Mentorship";
import Upcomingcalls from "./Upcomingcalls";
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from './style';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import AppSearchBar from '../../Components/AppSearchBar';
import { featuredCardData } from "../Network/NetworkData";
import { getNetworks, getMentorshipDetails, friendrAndCallRequest } from '../../Utils/apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from "notistack";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MentorshipMobileview from "./Mentorship/MentorshipMobileview";
import FilterIcon from '../../Assets/filter.svg';
import Menu from '@mui/material/Menu';
import RequestImage from '../../Assets/Events/NoDataSupport.png';
import { AppTabs } from "../../Components/AppTab";
import FilterListIcon from '@mui/icons-material/FilterList';
import useSpeechRecognition from '../../hooks/useSpeechRecognition';
import Images from '../../Assets/assetHelper';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const YourMentees: React.FunctionComponent<any> = (props) => {
  const AllYourMentees = props?.AllYourMentees;
  const upcomingCalls = props?.upcomingCalls;
  const CallrequestbyOthersData = props?.CallrequestbyOthersData;
  const mentorshipDetails = props?.mentorshipDetails; // Use prop
  const CallRequests = props?.CallRequests; // Use prop
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange1 = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  console.log(AllYourMentees, "AllYourMenteesAllYourMenteesAllYourMentees");

  const [featuredCardData, setFeaturedCardData] = useState<any[]>([]);
  const [allFeaturedCardData, setAllFeaturedCardData] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });
  const [localSearchInput, setLocalSearchInput] = useState('');
  const [searchInput, setSearchInput] = useState<string>('');
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [Sortby, setSortby] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const sortOptions = ["A - Z", "Z - A", "Recently joined"];
  const isSortMenuOpen = Boolean(anchorEl);

  const [visibleCount, setVisibleCount] = useState(3);

  const handleSeeMore = () => {
    setVisibleCount(prev => prev + 2); // load 2 more
  };

  const [visibleCount1, setVisibleCount1] = useState(3);

  const handleSeeMore1 = () => {
    setVisibleCount1(prev => prev + 2); // load 2 more
  };

  const handleClick = () => {
    navigate(routes.setupPreference);
  };
  const handleChanges = (event: any) => {
    const sortOption = event.target.value;
    setSortby(sortOption);

    if (sortOption === "") {
      setFeaturedCardData(allFeaturedCardData);
      return;
    }

    const sortedData = [...featuredCardData].sort((a: any, b: any) => {
      const nameA = (a.contactDetails?.name || '').toLowerCase();
      const nameB = (b.contactDetails?.name || '').toLowerCase();

      if (sortOption === "A - Z") {
        return nameA.localeCompare(nameB);
      } else if (sortOption === "Z - A") {
        return nameB.localeCompare(nameA);
      } else if (sortOption === "Recently joined") {
        const dateA = new Date(a.contactDetails?.createdDate || 0).getTime();
        const dateB = new Date(b.contactDetails?.createdDate || 0).getTime();
        return dateB - dateA;
      }
      return 0;
    });

    setFeaturedCardData(sortedData);
  };
  const [values, setValues] = React.useState(0);

  const handleConnectionChange = (event: React.SyntheticEvent, newValue: number) => {
    setValues(newValue);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchInput(event.target.value);
    setSearchInput(event.target.value);
    filterJobs(allFeaturedCardData, selectedValues, event.target.value);
  };

  const [RecivedRequestData, setRecivedRequestData] = useState<any[]>([]);
  const [callRequests, setCallRequests] = useState<any[]>([]);

  useEffect(() => {
    const filteredMentees = AllYourMentees.filter((item: { isMentee: boolean; menteeConnectionRequestRejected: boolean; menteeConnectionRequestSent: boolean; }) =>
      item.isMentee === false &&
      item.menteeConnectionRequestRejected === false &&
      item.menteeConnectionRequestSent === true
    );
    setRecivedRequestData(filteredMentees);
    const menteesOnly = AllYourMentees.filter((item: { isMentee: boolean; }) => item.isMentee === true);
    setAllFeaturedCardData(menteesOnly);
    setFeaturedCardData(menteesOnly);

  }, []);

  useEffect(() => {
    setCallRequests(CallrequestbyOthersData || []);
  }, [CallrequestbyOthersData]);
  const filterJobs = (jobs: any[], criteria: any, searchInput: string) => {
    // Map filter keys to correct mentor data structure
    const getNestedFieldValue = (job: any, key: string): any => {
      const pathMap: Record<string, string> = {
        locations: 'contactDetails.city',
        graduationYear: 'contactDetails.batch',
        currentCompany: 'contactDetails.company',
        postCompany: 'contactDetails.postCompany',
        industry: 'contactDetails.industry',
        // fallback for search fields
        City__c: 'contactDetails.city',
        Year_of_Graduation__c: 'contactDetails.batch',
        Industry__c: 'contactDetails.industry',
        Current_Company__c: 'contactDetails.company',
        Post_Company__c: 'contactDetails.postCompany',
      };
      const path = pathMap[key] || key;
      return path.split('.').reduce((obj, part) => obj?.[part], job);
    };

    const filteredJobs = jobs.filter((job: any) => {
      // Filtering by criteria
      const matchesCriteria = Object.keys(criteria).every((key) => {
        const selectedValues = criteria[key];
        if (!selectedValues || selectedValues.length === 0) return true;
        const jobValue = getNestedFieldValue(job, key);
        if (Array.isArray(selectedValues)) {
          return selectedValues.includes(jobValue);
        }
        return jobValue === selectedValues;
      });

      // Search fields
      const searchFields = [
        'contactDetails.company',
        'contactDetails.designation',
        'contactDetails.industry',
        'contactDetails.interests',
        'contactDetails.name',
        'contactDetails.occupation',
        'contactDetails.postCompany',
        'contactDetails.program',
        'contactDetails.street',
        'contactDetails.batch',
      ];
      const matchesSearch = searchFields.some((field) => {
        const jobFieldValue = field.split('.').reduce((obj, part) => obj?.[part], job);
        return jobFieldValue?.toString().toLowerCase().includes(searchInput.toLowerCase());
      });

      return matchesCriteria && (searchInput ? matchesSearch : true);
    });
    setFeaturedCardData(filteredJobs);
  };

  const { startListening, stopListening, isSupported } = useSpeechRecognition({
    onResult: (speechResult: string) => {
      setLocalSearchInput(speechResult);
      setSearchInput(speechResult);
      filterJobs(allFeaturedCardData, selectedValues, speechResult);
    },
    onStart: () => setNotificationOpen(true),
    onEnd: () => setNotificationOpen(false),
    onError: (event: Event) => {
      console.error('Speech recognition error:', event);
      setNotificationOpen(false);
    },
  });

  const handleMicHold = () => {
    if (!isSupported) {
      console.log('Speech recognition not supported');
      return;
    }
    startListening();
  };

  const handleMicRelease = () => {
    stopListening();
  };
  const toggleFilter = () => {
    setIsFilterOpen(true);
  };
  const closeFilter = () => {
    setIsFilterOpen(false);
  };
  const handleFilterChange = (filterName: string, value: any) => {
    setSelectedValues((prevValues: any) => ({
      ...prevValues,
      [filterName]: value,
    }));
  };

  const applyFilters = () => {
    const filteredData = allFeaturedCardData.filter((user) => {
      const { locations, graduationYear, currentCompany, postCompany, industry } = selectedValues;
      const location = user?.contactDetails?.city;
      const year = user?.contactDetails?.batch;
      const company = user?.contactDetails?.company;
      const post = user?.contactDetails?.city;
      const ind = user?.contactDetails?.city;

      const locationMatches = locations.length ? locations.includes(location) : true;
      const yearMatches = graduationYear ? year === graduationYear : true;
      const companyMatches = currentCompany ? company === currentCompany : true;
      const postMatches = postCompany ? post === postCompany : true;
      const industryMatches = industry ? ind === industry : true;
      return locationMatches && yearMatches && companyMatches && postMatches && industryMatches;
    });
    setFeaturedCardData(filteredData);
  };
  const clearFilters = () => {
    setSelectedValues({
      locations: [],
      graduationYear: '',
      currentCompany: '',
      postCompany: '',
      industry: '',
    });
    setFeaturedCardData(allFeaturedCardData);
  };
  const getUniqueOptions = (field: string) => {
    // Map field to correct mentor data structure
    const fieldMap: Record<string, string> = {
      Year_of_Graduation__c: 'contactDetails.batch',
      Current_Company__c: 'contactDetails.company',
      Post_Company__c: 'contactDetails.postCompany',
      Industry__c: 'contactDetails.industry',
    };
    const mappedField = fieldMap[field] || field;
    const uniqueOptions = Array.from(
      new Set(allFeaturedCardData.map((user) => mappedField.split('.').reduce((obj, part) => obj?.[part], user)))
    ).filter(Boolean);

    if (field === 'Year_of_Graduation__c') {
      return uniqueOptions.sort((a, b) => {
        const yearA = parseInt(String(a), 10);
        const yearB = parseInt(String(b), 10);

        if (Number.isNaN(yearA) && Number.isNaN(yearB)) {
          return String(a).localeCompare(String(b));
        }
        if (Number.isNaN(yearA)) return 1;
        if (Number.isNaN(yearB)) return -1;
        return yearB - yearA;
      });
    }

    return uniqueOptions;
  };

  const removeConnectionRequestFromList = (mentorshipId?: string) => {
    if (!mentorshipId) return;
    setRecivedRequestData((prev) => prev.filter((item) => item?.mentorshipId !== mentorshipId));
  };

  const removeCallRequestFromList = (meetingId?: string) => {
    if (!meetingId) return;
    setCallRequests((prev) => prev.filter((item) => item?.meetingId !== meetingId));
  };

  const accpectRequest = (contactDetails: any) => {
    const data: any = {
      id: contactDetails?.[0]?.mentorshipId,
      data: {
        "Connection_Request_Approved__c": true
      }
    };
    friendrAndCallRequest(data).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar({
          message: 'Request Approved Successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        removeConnectionRequestFromList(contactDetails?.[0]?.mentorshipId);
        mentorshipDetails(); // Trigger update via prop
      } else {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      }
    });
  };

  const rejectRequest = (contactDetails: any) => {
    const data: any = {
      id: contactDetails?.[0]?.mentorshipId,
      data: {
        "Connection_Request_Rejected__c": true
      }
    };
    friendrAndCallRequest(data).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar({
          message: 'Request Rejected Successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        removeConnectionRequestFromList(contactDetails?.[0]?.mentorshipId);
        mentorshipDetails(); // Trigger update via prop
      } else {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      }
    });
  };

  const accpectCallRequest = (contactDetails: any) => {
    const data: any = {
      id: contactDetails?.[0]?.meetingId,
      data: {
        "Meeting_Request_Accepted__c": true
      }
    };
    friendrAndCallRequest(data).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar({
          message: 'Request Approved Successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        removeCallRequestFromList(contactDetails?.[0]?.meetingId);
        CallRequests(); // Trigger update via prop
      } else {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      }
    });
  };

  const rejectCallRequest = (contactDetails: any) => {
    const data: any = {
      id: contactDetails?.[0]?.meetingId,
      data: {
        "Meeting_Request_Rejected__c": true
      }
    };
    friendrAndCallRequest(data).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar({
          message: 'Request Rejected Successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        removeCallRequestFromList(contactDetails?.[0]?.meetingId);
        CallRequests(); // Trigger update via prop
      } else {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      }
    });
  };
  const [showAll, setShowAll] = useState(false); // state moved to parent

  const handleToggleShowAll = () => {
    navigate('/mentorship/view-all-mentorship', {
      state: {
        title: 'Your Mentees',
        data: featuredCardData,
      },
    });
    setShowAll((prev) => !prev);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSortButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSortSelect = (sortOption: string) => {
    setSortby(sortOption);
    setAnchorEl(null); // Close menu after selection

    if (!sortOption) {
      setFeaturedCardData(allFeaturedCardData);
      return;
    }

    const sortedData = [...featuredCardData].sort((a: any, b: any) => {
      const contactA = a?.contactDetails || {};
      const contactB = b?.contactDetails || {};

      if (sortOption === 'A - Z') {
        return (contactA.name || '').toLowerCase().localeCompare((contactB.name || '').toLowerCase());
      }

      if (sortOption === 'Z - A') {
        return (contactB.name || '').toLowerCase().localeCompare((contactA.name || '').toLowerCase());
      }

      if (sortOption === 'Recently joined') {
        const dateA = new Date(contactA.createdDate || contactA.CreatedDate || a?.CreatedDate || a?.createdDate || 0).getTime();
        const dateB = new Date(contactB.createdDate || contactB.CreatedDate || b?.CreatedDate || b?.createdDate || 0).getTime();
        return dateB - dateA; // latest first
      }

      return 0;
    });

    setFeaturedCardData(sortedData);
  };
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const handleSortMenuClose1 = () => {
    setAnchorEl(null);
  };

  const handleSortButtonClick1 = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl1(event.currentTarget);
  };


  return (
    <div>
      <Grid container style={{ height: isMobile ? "auto" : "calc(100vh - 207px)" }}>
        <Grid
          item
          lg={8}
          xl={8}
          xs={12}
          sx={{ backgroundColor: "white", borderRadius: "8px", padding: 2, pb: 2 }}
        >
          <Grid style={{ marginBottom: 10 }} container display="flex" alignItems="center" justifyContent="space-between">
            <Grid item style={{ display: 'flex', justifyContent: 'space-between', width: isMobile ? '100%' : 'none' }}>
              <Typography
                sx={{
                  fontSize: '16px',
                  color: '#373A45',
                  fontWeight: '500',
                  textAlign: 'start',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                  '@media (min-width: 1920px) and (max-width: 1940px)': {
                    fontSize: '20px !important',
                  },
                }}
              >
                {'Your Mentees'}
              </Typography>
              {isMobile && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={handleToggleShowAll}
                  sx={{
                    ml: 2,

                  }}
                >
                  {showAll ? 'Show Less' : 'View All'}
                </Button>
              )}
            </Grid>

            <Grid item display={isMobile ? "none" : "flex"} alignItems={"center"} justifyContent={"end"} gap={"12px"}  >
              <div>
                <AppSearchBar handleMicHold={handleMicHold} handleMicRelease={handleMicRelease} localSearchInput={localSearchInput} handleChange={handleChange} openSnackbar={notificationOpen} />
              </div>
              <div>
                <FormControl sx={{ width: '100%', float: "right", fontSize: "12px" }} size="small">
                  <Button
                    size="small"
                    variant='contained'
                    color="info"
                    endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                    sx={{ width: 'fitContent', height: 36, minHeight: 36 }}
                    onClick={handleSortButtonClick}
                  >
                    <Typography sx={{ fontWeight: 500 }}>{Sortby ? `${Sortby}` : "Sort by"}</Typography>
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    open={isSortMenuOpen}
                    onClose={handleSortMenuClose}
                    PaperProps={{
                      sx: {
                        borderRadius: 2,
                        minWidth: 180,
                        boxShadow: 3,
                        mt: 1,
                        backgroundColor: "#FFFFFF",
                      }
                    }}
                  >
                    <MenuItem
                      onClick={() => handleSortSelect("")}
                      selected={Sortby === ""}
                      sx={{ fontWeight: Sortby === "" ? 600 : 400 }}
                    >
                      Clear
                    </MenuItem>
                    {sortOptions.map(option => (
                      <MenuItem
                        key={option}
                        onClick={() => handleSortSelect(option)}
                        selected={Sortby === option}
                        sx={{ fontWeight: Sortby === option ? 600 : 400 }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Menu>
                </FormControl>
              </div>
              <div>
                <Button
                  size="small"
                  variant='contained'
                  color="info"
                  endIcon={<FilterListIcon style={{ fontSize: '24px' }} />}
                  sx={{ height: 36, minHeight: 36 }}
                  onClick={(event) => {
                    toggleFilter();
                    handleSortButtonClick1(event);
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>Filters</Typography>
                </Button>

                <Popover
                  anchorEl={anchorEl1}
                  open={isFilterOpen}
                  onClose={closeFilter}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    sx: {
                      borderRadius: 2,
                      minWidth: 300,
                      boxShadow: 3,
                      mt: 1,
                      backgroundColor: "#FFFFFF",
                      p: 2
                    },
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Grid container>
                      <Grid item md={6} style={{ justifyContent: "start", display: "flex", alignItems: "center" }}>
                        <Box>
                          <Typography style={{ fontWeight: "500" }}>Filters</Typography>
                        </Box>
                      </Grid>
                      <Grid item md={6} style={{ justifyContent: "end", display: "flex", alignItems: "center" }}>
                        <IconButton style={{ float: "right" }} onClick={closeFilter}>
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box
                    textAlign="left"
                    sx={{
                      flex: 1,
                      overflowY: "auto",
                      // padding: 1,
                      paddingBottom: 1
                    }}
                  >
                    <InputLabel id="location-label" style={{ fontSize: 14, marginTop: 6 }}>Location</InputLabel>
                    <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                      <Select
                        labelId="location-label"
                        multiple
                        value={selectedValues.locations}
                        onChange={(e) => handleFilterChange('locations', e.target.value)}
                        renderValue={(selected) => selected.join(', ')}
                      >
                        {Array.from(new Set(allFeaturedCardData.map((user) => user?.contactDetails?.city)))
                          .map((city) => (
                            <MenuItem key={city} value={city}>
                              {city}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>

                    <InputLabel id="year-label" style={{ fontSize: 14, marginTop: 6 }}>Year of Graduation</InputLabel>
                    <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                      <Select
                        labelId="year-label"
                        value={selectedValues.graduationYear}
                        onChange={(e) => handleFilterChange('graduationYear', e.target.value)}
                      >
                        {getUniqueOptions('Year_of_Graduation__c').map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <InputLabel id="company-label" style={{ fontSize: 14, marginTop: 6 }}>Current Company</InputLabel>
                    <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                      <Select
                        labelId="company-label"
                        value={selectedValues.currentCompany}
                        onChange={(e) => handleFilterChange('currentCompany', e.target.value)}
                      >
                        {getUniqueOptions('Current_Company__c').map((company) => (
                          <MenuItem key={company} value={company}>
                            {company}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <InputLabel id="post-company-label" style={{ fontSize: 14, marginTop: 6 }}>Post Company</InputLabel>
                    <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                      <Select
                        labelId="post-company-label"
                        value={selectedValues.postCompany}
                        onChange={(e) => handleFilterChange('postCompany', e.target.value)}
                      >
                        {getUniqueOptions('Post_Company__c').map((postCompany) => (
                          <MenuItem key={postCompany} value={postCompany}>
                            {postCompany}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <InputLabel id="industry-label" style={{ fontSize: 14, marginTop: 6 }}>Industry</InputLabel>
                    <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                      <Select
                        labelId="industry-label"
                        value={selectedValues.industry}
                        onChange={(e) => handleFilterChange('industry', e.target.value)}
                      >
                        {getUniqueOptions('Industry__c').map((industry) => (
                          <MenuItem key={industry} value={industry}>
                            {industry}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="end"
                    sx={{
                      // padding: 2,
                      gap: 2,
                      backgroundColor: 'white',
                      marginTop: 'auto'
                    }}
                  >
                    <Button variant='contained' size='medium'
                      color='secondary' onClick={clearFilters} >Clear</Button>
                    <Button variant='contained' size='medium'
                      color='primary' onClick={applyFilters} >Apply</Button>
                  </Box>
                </Popover>

              </div>
              <div>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => { navigate(routes.setupPreference); }}
                >
                  Edit preferences
                </Button>
              </div>

            </Grid>



          </Grid>
          {isMobile ? (
            <MentorshipMobileview cardData={featuredCardData} title={''} showAll={showAll} />
          ) : (
            <Grid className={`scrollbar-cusgray ${classes.cardContainer}`}>
              <MentorshipContainer cardData={featuredCardData} title={''} showAll={showAll} />
            </Grid>
          )}
        </Grid>
        <Grid
          item
          lg={4}
          xl={4}
          xs={12}
          sx={{
            mt: {
              xs: 2,
              sm: 0,
            },
          }}
        >

          <Grid sx={{ backgroundColor: "white", borderRadius: "8px", padding: 2, ml: { xs: 0, sm: 2 }, marginBottom: 2, height: isMobile ? "auto" : "49%", display: 'flex', flexDirection: 'column' }}>

            <AppTabs
              value={values}
              onChange={handleConnectionChange}
              tabs={["Connection requests", "Call requests"]}
            />
            {/* <Typography fontWeight={500}>Call Requests Received</Typography> */}
            {/* <hr style={{ opacity: ".15" }} /> */}
            <CustomTabPanel value={values} index={0}>
              {RecivedRequestData.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 3, color: '#888', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={RequestImage} alt="No Requests" style={{ width: 72, marginBottom: 16 }} />
                  <Typography variant="body2" sx={{ color: '#585A64', fontSize: 14, fontWeight: 500 }}>
                    -No Connection Requests-
                  </Typography>
                </Box>
              ) : (
                <>
                  {
                    RecivedRequestData.slice(0, visibleCount).map((item, index) => {
                      const { contactDetails } = item;
                      return (
                        <Grid
                          container
                          key={index}
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            padding: '16px 0',
                            borderBottom: '1px solid #F0F0F0',
                            '&:last-child': { borderBottom: 'none' },
                          }}
                        >
                          <Grid item>
                            <img
                              src={contactDetails?.profilePicURL || Images.Images.NoDataTheme}
                              alt="profile"
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                objectFit: 'cover',
                              }}
                            />
                          </Grid>

                          <Grid item xs>
                            <Box sx={{ ml: 2 }}>
                              <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#222' }}>
                                {contactDetails?.name || 'Name not available'}
                              </Typography>
                              <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#888' }}>
                                {contactDetails?.designation || 'Designation'}
                                {contactDetails?.batch ? `, Batch ${contactDetails.batch}` : ''}
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <IconButton
                                sx={{
                                  backgroundColor: '#FAB400',
                                  color: '#fff',
                                  width: 30,
                                  height: 30,
                                  borderRadius: 2,
                                  '&:hover': { backgroundColor: '#e0a200' },
                                }}
                                onClick={() => accpectRequest([item])}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                sx={{
                                  backgroundColor: '#E8EBF3',
                                  color: '#545454',
                                  width: 30,
                                  height: 30,
                                  borderRadius: 2,
                                  '&:hover': { backgroundColor: '#d3d7e3' },
                                }}
                                onClick={() => rejectRequest([item])}
                              >
                                <CloseIcon />
                              </IconButton>
                            </Box>
                          </Grid>
                        </Grid>
                      );
                    })}
                  {visibleCount < RecivedRequestData.length && (
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                      <Button
                        onClick={handleSeeMore}
                        style={{
                          borderRadius: 4,
                          padding: '6px 12px',
                          fontSize: 14,
                          cursor: 'pointer',
                        }}
                      >
                        View More
                      </Button>
                    </Box>
                  )}
                </>
              )}

            </CustomTabPanel>
            <CustomTabPanel value={values} index={1}>
            {callRequests.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 3, color: '#888', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                <img src={RequestImage} alt="No Requests" style={{ width: 72, marginBottom: 16 }} />
                <Typography variant="body2" sx={{ color: '#585A64', fontSize: 14, fontWeight: 500 }}>
                  -No Call Request-
                </Typography>
              </Box>
            ) : (
              <>{
                callRequests.slice(0, visibleCount1).map((item: any, index: any) => {
                  return (
                    <Grid
                      container
                      key={index}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        padding: '16px 0',
                        borderBottom: '1px solid #F0F0F0',
                        '&:last-child': { borderBottom: 'none' },
                      }}
                    >
                      {/* Profile Image */}
                      <Grid item>
                        <img
                          src={item?.userImageUrl || Images.Images.NoDataTheme}
                          alt="profile"
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      </Grid>

                      {/* Name and Details */}
                      <Grid item xs>
                        <Box sx={{ ml: 2 }}>
                          <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#222' }}>
                            {item?.meetWithUser || 'Name not available'}
                          </Typography>
                          <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#888' }}>
                            {item?.meetTitle || 'Meet Title'}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Action Buttons */}
                      <Grid item>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            sx={{
                              backgroundColor: '#FAB400',
                              color: '#fff',
                              width: 30,
                              height: 30,
                              borderRadius: 2,
                              '&:hover': { backgroundColor: '#e0a200' },
                            }}
                            onClick={() => accpectCallRequest([item])}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            sx={{
                              backgroundColor: '#E8EBF3',
                              color: '#545454',
                              width: 30,
                              height: 30,
                              borderRadius: 2,
                              '&:hover': { backgroundColor: '#d3d7e3' },
                            }}
                            onClick={() => rejectCallRequest([item])}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  );
                })}
                {visibleCount1 < callRequests.length && (
                  <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                      onClick={handleSeeMore1}
                      style={{
                        borderRadius: 4,
                        padding: '6px 12px',
                        fontSize: 14,
                        cursor: 'pointer',
                      }}
                    >
                      View More
                    </Button>
                  </Box>
                )}
              </>
            )}
            </CustomTabPanel>
          </Grid>
          <Grid sx={{ backgroundColor: "white", borderRadius: "8px", paddingX: 2, pb: 2, ml: { xs: 0, sm: 2 }, marginBottom: 2, height: isMobile ? "auto" : "49%", overflowY: 'scroll' }} className="scrollbar-cusgray">
            <Grid>
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  width: "100%",
                  background: "white",   // ensures text doesn't overlap behind scroll
                  zIndex: 10,            // keeps it above the list
                  paddingBottom: "4px",
                  paddingTop: 16
                }}
              >
                <Typography fontWeight={500}>Upcoming Calls</Typography>
                <hr style={{ opacity: ".15" }} />
              </div>
              <Grid>
                {upcomingCalls && Array.isArray(upcomingCalls) && upcomingCalls.length > 0 ? (
                  <Upcomingcalls upcomingCalls={upcomingCalls} />
                ) : (
                  <Typography>No upcoming calls available</Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default YourMentees;
